import { useState, useEffect } from 'react';
import { useToast } from '@/shared/contexts';
import { Brand, useLibertyPage } from '@/shared/components/liberty';
import { SiteFooter } from '@/features/Home/components/SiteFooter';
import { REFERRAL_STORAGE_KEY } from '@/shared/services/referralsService';
import CadastroEmail from './CadastroEmail';
import CadastroCelular from './CadastroCelular';
import CadastroGoogle from './CadastroGoogle';

type Mode = 'email' | 'celular' | 'google';

const TABS: { key: Mode; label: string }[] = [
  { key: 'email', label: '✉ Email' },
  { key: 'celular', label: '☎ Celular' },
  { key: 'google', label: 'G Google' },
];

const HEAD: Record<Mode, { title: string; subtitle: string }> = {
  email: { title: 'Crie sua conta', subtitle: 'Cadastre-se com email — código de 6 dígitos enviado para confirmar.' },
  celular: { title: 'Crie sua conta', subtitle: 'Cadastre-se com celular — código SMS de 6 dígitos.' },
  google: { title: 'Entrar com Google', subtitle: 'Use sua conta Google para entrar — sem digitar senha.' },
};


export default function CadastroPage() {
  useLibertyPage('auth-page');   // titulo = BRAND_NAME ("Cabal Liberty EP39")
  const { setOpenVerify } = useToast();
  const [mode, setMode] = useState<Mode>('email');

  // Captura ?ref= da URL -> localStorage. Vale pra QUALQUER aba (email/celular/
  // google) — cada fluxo le esse valor e envia no cadastro.
  useEffect(() => {
    try {
      const code = new URLSearchParams(window.location.search).get('ref');
      if (code) localStorage.setItem(REFERRAL_STORAGE_KEY, code.trim().toUpperCase().slice(0, 10));
    } catch { /* ignore */ }
  }, []);

  const goLogin = () => setOpenVerify(true);

  return (
    <>
      <header className="auth-header">
        <Brand />
        <button className="btn btn-dark" onClick={goLogin}>↪ Entrar</button>
      </header>

      {/* Cenario do cadastro: fundo + personagem (Espadachim roxo) num bloco SO' com a proporcao do
          fundo (1672x941) em "cover" — o personagem e' posicionado em % do bloco, entao os dois
          andam juntos em qualquer resolucao (pe' em cima da pedra, igual ao exemplo aprovado). */}
      <div className="auth-scene" aria-hidden="true">
        <img className="auth-scene-char" src="/assets/Untchar4.webp" alt="" />
      </div>

      <main className="auth-shell">
        {/* coluna esquerda vazia: o espaco e' do personagem fixo */}
        <section className="auth-art" aria-hidden="true"></section>

        <section className="auth-card ornate-card">
          <div className="auth-card-head">
            <small>Novo aventureiro</small>
            <h2>{HEAD[mode].title}</h2>
            <p>{HEAD[mode].subtitle}</p>
          </div>

          <div className="auth-tabs">
            {TABS.map((t) => (
              <button key={t.key} type="button" className={mode === t.key ? 'active' : undefined} onClick={() => setMode(t.key)}>
                {t.label}
              </button>
            ))}
          </div>

          {mode === 'email' && <CadastroEmail />}
          {mode === 'celular' && <CadastroCelular />}
          {mode === 'google' && <CadastroGoogle />}

          <p className="auth-login">
            Já tem uma conta? <a href="#" onClick={(e) => { e.preventDefault(); goLogin(); }}>Fazer login</a>
          </p>
        </section>
      </main>

      <SiteFooter hrefBase="/" />
    </>
  );
}
